import styled, { css } from 'styled-components';

interface StyledProps {
  isSelected: boolean;
}

export const YesNoButtonWrapper = styled.div`
  ${(props: StyledProps) =>
    props.isSelected &&
    css`
      & > button {
        background-color: grey !important;
        color: white !important;
      }
    `}
  margin: 0 8px;
`;

export const NextButtonWrapper = styled.div`
  padding: 1em;
`;
